import { render, staticRenderFns } from "./xiaoxiao.vue?vue&type=template&id=4b2e7818&scoped=true&"
import script from "./xiaoxiao.vue?vue&type=script&lang=js&"
export * from "./xiaoxiao.vue?vue&type=script&lang=js&"
import style0 from "./xiaoxiao.vue?vue&type=style&index=0&id=4b2e7818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e7818",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kanghuang/project/Javascript/vue/letter_en/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VImg,VLayout})
